// extracted by mini-css-extract-plugin
module.exports = {"loading":"index_loading__YWcOv"};